import { defineMessage } from 'services/localization';

export const messages = {
    friendlyNameColumnText: defineMessage('name'),
    dateColumnText: defineMessage('date'),
    paymentDateColumnText: defineMessage('payment_date'),
    requesterColumnText: defineMessage('requester'),
    workflowStepColumnText: defineMessage('workflow_step'),
    amountColumnText: defineMessage('amount'),
    statusColumnText: defineMessage('status_1'),
    requestAmountEmptyValue: defineMessage('currency_1'),
    receivedFromReceiptBankOrigin: defineMessage('received_from_dext_prepare'),
    pulledFromOrigin: defineMessage('pulled_from_integrationname'),
    onApproval: defineMessage('on_approval'),
    rejected: defineMessage('rejected'),
    approved: defineMessage('approved'),
    cancelled: defineMessage('cancelled'),
    onReview: defineMessage('on_review'),
    onHold: defineMessage('on_hold'),
    reviewStepText: defineMessage('review_step_2'),
};
